import { FileText, Search, MessageCircle, Truck } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const steps = [
  {
    icon: FileText,
    step: "01",
    title: "Déposez votre demande",
    description: "Formulaire simple avec les détails de votre colis.",
  },
  {
    icon: Search,
    step: "02",
    title: "Transporteurs proposés",
    description: "GoBledPro identifie des transporteurs disponibles.",
  },
  {
    icon: MessageCircle,
    step: "03",
    title: "Mise en relation",
    description: "Contactez directement les transporteurs disponibles.",
  },
  {
    icon: Truck,
    step: "04",
    title: "Transport réalisé",
    description: "Le transporteur s'occupe de votre colis.",
  },
];

const HowItWorksSection = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="fonctionnement" className="py-12 md:py-20 bg-muted/50">
      <div ref={ref} className="container mx-auto px-4">
        {/* Header */}
        <div className={`text-center max-w-3xl mx-auto mb-8 md:mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-medium mb-4">
            Processus simple
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3">
            Comment ça marche ?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground">
            En 4 étapes simples, envoyez votre colis en toute sérénité.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className={`relative group transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
              style={{ transitionDelay: `${200 + index * 150}ms` }}
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-gradient-to-r from-secondary/50 to-transparent z-0" />
              )}
              
              <div className="relative z-10 bg-card border border-border rounded-xl p-4 md:p-5 h-full hover-lift">
                {/* Step number */}
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary text-secondary-foreground rounded-full flex items-center justify-center font-bold text-xs">
                  {step.step}
                </div>
                
                {/* Icon */}
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                  <step.icon className="w-6 h-6 md:w-7 md:h-7 text-primary-foreground" />
                </div>
                
                {/* Content */}
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
